import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { ConcurObjectDataset } from 'app/model/dataset/concur.dataset';
import { ConcurLinkedService } from 'app/model/linkedservice/concur.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const concurObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(ConcurObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Concur_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(ConcurLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-concur'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
